import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { name, email, phone, address, avatar, company },
} = checkout;

const validations = Yup.object().shape({
  // [avatar.name]: Yup.mixed().required(name.errorMsg),
  [name.name]: Yup.string().required(name.errorMsg),
  [address.name]: Yup.string(),
  [company.name]: Yup.string().required(company.errorMsg),
//   [email.name]: Yup.string().when([], (schema) => {
//       const urlContainsCreate = window.location.href.includes("create");
//       const urlContainsEdit = window.location.href.includes("edit");
//       if (urlContainsCreate) {
//           return schema.required(email.errorMsg).email(email.invalidMsg);
//       } else if (urlContainsEdit) {
//           return schema.notRequired();
//       }

//       return schema;
//   }),
  [phone.name]: Yup.string().matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg),
});

export default validations;
